var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.$v.CEP_MASK),expression:"$v.CEP_MASK"}],attrs:{"label":"CEP","return-masked-value":"","loading":_vm.loading,"value":_vm.value},on:{"input":_vm.onInput,"focus":_vm.onFocus}},'v-text-field',_vm.attributes,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }